var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSelect } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import noop from 'lodash/noop';
import memoize from 'memoize-one';
import { PureComponent } from 'react';
import { MATCH_BOOLEAN_DEFAULT_VALUE } from 'components/automations/components/constants';
import { VariableScope, } from 'components/automations/components/nodeTypes/types';
import styles from './matchBoolean.module.scss';
const OPTIONS = [
    {
        name: 'True',
        id: 'true',
    },
    {
        name: 'False',
        id: 'false',
    },
];
const ACCEPTED_VALUES = ['true', 'false'];
export class MatchBoolean extends PureComponent {
    constructor(props) {
        super(props);
        this.getInputAdaptor = memoize(this.getInputAdaptor);
    }
    onChange(value) {
        var _a, _b;
        const { input } = this.props;
        input.onChange({
            scope: VariableScope.INPUT,
            values: [
                {
                    value,
                    meta: {
                        label: (_b = (_a = OPTIONS.find((opt) => opt.id === value)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
                    },
                },
            ],
        });
    }
    getInputAdaptor(input) {
        var _a, _b;
        const match = ((_b = (_a = input.value) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) || MATCH_BOOLEAN_DEFAULT_VALUE;
        return Object.assign(Object.assign({}, input), { onChange: this.onChange, onBlur: noop, onFocus: noop, value: !Array.isArray(match) && ACCEPTED_VALUES.includes(match === null || match === void 0 ? void 0 : match.value)
                ? match.value
                : 'true' });
    }
    render() {
        const { input, meta } = this.props;
        const inputAdaptor = this.getInputAdaptor(input);
        return (_jsx(FieldSelect, { className: styles.root, input: inputAdaptor, meta: {
                error: meta === null || meta === void 0 ? void 0 : meta.error,
                touched: meta === null || meta === void 0 ? void 0 : meta.touched,
            }, items: OPTIONS, dropdownProps: { fixed: true }, noLabel: true, noAlert: true }));
    }
}
__decorate([
    boundMethod
], MatchBoolean.prototype, "onChange", null);
